// extracted by mini-css-extract-plugin
export var block = "instant-system-widget-block-module--block--3e345";
export var blockHeader = "instant-system-widget-block-module--blockHeader--8ebae";
export var blockIti = "instant-system-widget-block-module--blockIti--aa541";
export var blockPicto = "instant-system-widget-block-module--blockPicto--804d0";
export var mapButton = "instant-system-widget-block-module--mapButton--51486";
export var title = "instant-system-widget-block-module--title--8537e";